import { ICommand, IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IAPAvailableTermsDatasource } from '../datasources/ap_available_terms_datasource';

angular
  .module('capability-ng-academic-planner')
  .factory(
    'loadAvailableTermsCommand',
    (
      log: any,
      defineCommandORM: IDefineCommand,
      $http: ng.IHttpService,
      ngAPAvailableTermsDatasource: IAPAvailableTermsDatasource
    ): ICommand => {
      return defineCommandORM(
        'loadAvailableTermsCommand',
        function loadAvailableTermsCommand(deferred: ng.IDeferred<IQuery[]>, studentNk: string): void {
          $http
            .get(`academicplan/students/${studentNk}/available_terms`)
            .then((response: ng.IHttpPromiseCallbackArg<any>) => {
              const { data: _availableTerms } = response.data;
              ngAPAvailableTermsDatasource.clear().write(_availableTerms);
              deferred.resolve();
            })
            .catch((e: ng.IHttpPromiseCallbackArg<any>) => {
              log.issue('failed to load available terms.');
              deferred.reject(e.data);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/commands/load_available_terms_command.ts